export function x(d) {
  return d[0];
}

export function y(d) {
  return d[1];
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-voronoi/src/point.js
// module id = ../../../../d3-voronoi/src/point.js
// module chunks = 3